<template>
  <div class="page">
    <div class="page-container container-buyer-requirements">
      <h2>Buyer Requirements</h2>
      <div class="page-data-grid data-grid-table">
        
        <div v-if="listing.buyer_credentials" class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/ribbon.svg" />
          <div>
            <label>Buyer Credentials</label>
            <span>{{ listing.buyer_credentials || 'N/A' }}</span>
          </div>
        </div>
        
        <div v-if="listing.buyer_organizations" class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/brain-gears.svg" />
          <div>
            <label>Organizations</label>
            <span>{{ listing.buyer_organizations || 'N/A' }}</span>
          </div>
        </div>
        
        <div v-if="listing.buyer_designations" class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/briefcase.svg" />
          <div>
            <label>Designations</label>
            <span>{{ listing.buyer_designations || 'N/A' }}</span>
          </div>
        </div>
        
        <div v-if="listing.buyer_location" class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/compass.svg" />
          <div>
            <label>Location</label>
            <span>{{ listing.buyer_location || 'N/A' }}</span>
          </div>
        </div>
        
        <div v-if="listing.buyer_other" class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/brain-work.svg" />
          <div>
            <label>Other</label>
            <span>{{ listing.buyer_other || 'N/A' }}</span>
          </div>
        </div>
      
      </div>
    </div>

    <div class="page-container container-retained-expenses">
      <h2>Annual Retained Expenses</h2>

      <div class="page-data-grid data-grid-table">
        <div class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/building.svg" />
          <div>
            <label>Lease</label>
            <span>{{ listing.retained_expenses_lease | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/employees.svg" />
          <div>
            <label>Employees</label>
            <span>{{ listing.retained_expenses_employees | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested no-bottom">
          <img src="../buyer-listing-details/full-details-content/assets/gears.svg" />
          <div>
            <label>Software</label>
            <span>{{ listing.retained_expenses_software | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/dots.svg" />
          <div>
            <label>Other</label>
            <span>{{ listing.retained_expenses_other | currency }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="page-container container-price-terms">
      <h2>Price &amp; Terms</h2>
      <div class="page-data-card">
        <div class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/target.svg" />
          <div>
            <span>{{ listing.asking_price | currency(true) }}</span>
            <label>Asking price</label>
          </div>
        </div>
      </div>

      <div class="price-terms-content">
        <div class="page-data-grid content-closing">
          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/handshake.svg" />
            <div>
              <span>{{ listing.cash_down || 0 }}%</span>
              <label>Cash Down</label>
            </div>
          </div>
          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/briefcase.svg" />
            <div>
              <span>{{ listing.escrow || 0 }}%</span>
              <label>Escrow</label>
            </div>
          </div>
          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/calendar.svg" />
            <div>
              <span>{{ closeDate }}</span>
              <label>Anticipated Close Date</label>
            </div>
          </div>
        </div>

        <div class="page-data-grid content-transition">
          <div class="page-data-item grid-title">Transition</div>
          <div class="page-data-item nested">
            <label>Consulting Timeline</label>
            <span>{{ listing.consulting_timeline || 'N/A' }}</span>
          </div>
          <div class="page-data-item nested">
            <label>Rainmaking Clause</label>
            <span>{{ listing.rainmaking_clause ? 'Yes' : 'No' }}</span>
          </div>
        </div>
      </div>
    </div>

    <BottomColorBar />
  </div>
</template>

<script>
import dateformat from 'dateformat'

import BottomColorBar from './partials/BottomColorBar'

export default {
  name: 'PdfPage6',
  components: {
    BottomColorBar,
  },
  props: {
    listing: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    closeDate () {
      return this.listing.anticipated_close_date
        ? dateformat(this.listing.anticipated_close_date, 'mmmm dd, yyyy')
        : 'N/A'
    },
  }
}
</script>

<style scoped>
.page {
  padding-top: 40px;
  padding-left: 50px;
  padding-right: 50px;
}

.page h2 {
  margin-bottom: 10px;
}

.page-data-card {
  grid-template-columns: auto;
}

.page-data-card .page-data-item {
  grid-template-columns: auto 1fr;
  grid-column-gap: 10px;
  align-items: center;
}

.page-data-card .page-data-item img {
  height: 75px;
  width: auto;
}

.page-data-card .page-data-item span {
  font-family: "SansationBold", sans-serif;
  font-size: 36pt;
  line-height: 38pt;
}

.page-data-card .page-data-item label {
  padding-left: 10px;

  font-family: "Sansation", sans-serif;
  font-size: 16pt;
  line-height: 18pt;
}

.page-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  padding: 10px 0;
}

.price-terms-content {
  flex-grow: 0;
  padding-left: 20px;

  display: flex;
}

.price-terms-content .content-closing {
  flex: 1 0 50%;
  grid-row-gap: 25px;
}

.price-terms-content .content-closing .page-data-item {
  grid-template-columns: 50px auto;
  grid-column-gap: 10px;
  align-items: center;
}

.price-terms-content .content-closing img {
  width: 45px;
}

.price-terms-content .content-closing label {
  font-family: "Sansation", sans-serif;
  font-size: 12pt;
  line-height: 13pt;
}

.price-terms-content .content-closing span {
  font-family: "SansationBold", sans-serif;
  font-size: 18pt;
  line-height: 20pt;
}

.price-terms-content .content-transition {
  flex: 1 0 50%;

  grid-template-rows: 50px 70px 70px;
  grid-row-gap: 10px;
}

.price-terms-content .content-transition .page-data-item {
  grid-template-columns: 1fr 120px;
  grid-column-gap: 10px;
}

.price-terms-content .content-transition .grid-title {
  grid-template-columns: auto;
  justify-content: center;
  align-items: center;

  background-color: #99CC33;
  color: white;
  font-family: "SansationBold", sans-serif;
  font-size: 12pt;
  line-height: 13pt;
}

.price-terms-content .content-transition .page-data-item:nth-child(2) * {
  background-color: #99CC3320;
}

.price-terms-content .content-transition .page-data-item:nth-child(3) * {
  background-color: #F2F2F2;
}

.price-terms-content .content-transition .page-data-item * {
  padding: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/PdfPage6.vue